import React from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import useStyles from './styles';

import API from '../../../services/api';

CustomSelect.defaultProps = {
  title: '',
  first: '',
  fetch: null,
  autoWidth: true,
  required: true,
  value: 0,
  mount: true,
};

export default function CustomSelect({ children, ...props }) {
  const classes = useStyles();
  const load = React.useRef(true);
  const [state, setState] = React.useState({ data: [] });
  const [value, setValue] = React.useState(0);

  function fetch() {
    if (props.fetch) {
      console.log('loading custom select...');
      const profile_id = Number(API.encryptedSessionStorage.getItem('profile_id', API.encryptedSessionStorage.getTokenData().uid));
      if (profile_id === 1) {
        console.log({ filter: props.filter });
        props
          .fetch({ geq_profile_id: profile_id, ...props.filter })
          .then(onSuccess)
          .catch(onFailure);
      } else {
        console.log({ filter: props.filter });
        props
          .fetch({ geq_profile_id: profile_id, ...props.filter })
          .then(onSuccess)
          .catch(onFailure);
      }
    }
  }

  function componentDidMount() {
    if (props.mount) {
      fetch();
    }
    return function componentWillUnmount() {};
  }

  React.useEffect(componentDidMount, []);

  function filterChanged() {
    if (props.filter) {
      fetch();
    }
    return function filterChanged() {};
  }

  React.useEffect(filterChanged, props.filter);

  function onSuccess(response) {
    if (load.current && response.data) {
      setState(response.data);
      if (response.data.data.find((item) => item.id === props.value)) {
        setValue(props.value);
      }
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      console.log(error.toString());
    }
  }

  function handleOnChange(event) {
    event.preventDefault();
    setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  return (
    <FormControl className={classes.formControl} required={props.required} error={props.error || false}>
      <InputLabel>{props.helperText ? props.helperText : props.title}</InputLabel>
      <Select value={value} autoWidth={props.autoWidth} onKeyDown={props.onKeyDown} onChange={handleOnChange} onFocus={props.onFocus}>
        <MenuItem value={0} disabled>
          <em>{props.first}</em>
        </MenuItem>
        {state.data.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
